import { render, staticRenderFns } from "./DeleteOperator.vue?vue&type=template&id=70ed12bc"
import script from "./DeleteOperator.vue?vue&type=script&lang=js"
export * from "./DeleteOperator.vue?vue&type=script&lang=js"
import style0 from "./DeleteOperator.vue?vue&type=style&index=0&id=70ed12bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports